export default __webpack_public_path__ + "static/media/rema.5a0053bc.png";